/**
 * Microsoft & Azure Icons
 * Official icons sourced from n8n's MIT-licensed repository
 * https://github.com/n8n-io/n8n/tree/master/packages/nodes-base/nodes/Microsoft
 */

import React from 'react';

interface IconProps {
  size?: number | string;
  className?: string;
  color?: string;
}

// Microsoft Teams Icon (official from n8n)
export const MicrosoftTeams: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 2381.4 2354.5"
    className={className}
  >
    <path fill="#5558af" d="M2015.6 899.2c19.5 19.5 42.5 35 67.9 45.8 53 22.2 112.7 22.2 165.8 0 51.2-21.8 92-62.5 113.7-113.7 22.2-53 22.2-112.7 0-165.8-21.8-51.2-62.5-92-113.7-113.7-53-22.2-112.7-22.2-165.8 0-51.2 21.8-92 62.5-113.7 113.7-22.2 53-22.2 112.7 0 165.8 10.8 25.3 26.4 48.4 45.8 67.9m-62.4 197.8v642.1h107c36.8-.2 73.4-3.6 109.5-10.4 36.3-6.4 71.3-18.6 103.7-36.2 30.6-16.6 57-40 77.3-68.2 21.3-31.3 32-68.6 30.5-106.5V1097zm-346.8-269.2c28.4.2 56.6-5.5 82.8-16.7 51.2-21.8 91.9-62.5 113.6-113.7 22.2-53 22.2-112.7-.1-165.8-21.8-51.2-62.5-92-113.7-113.7-26.2-11.2-54.4-16.9-82.9-16.7-28.3-.2-56.3 5.5-82.3 16.7-19.4 8.3-25.5 19.1-52.2 32.1v329c26.8 13.1 32.8 23.8 52.2 32.1 26.1 11.3 54.2 16.9 82.6 16.7m-134.8 1081.1c26.8 5.8 36.4 10.3 55.4 12.9 20.8 3 41.8 4.5 62.8 4.6 32.4-.2 64.8-3.6 96.5-10.4 32.3-6.5 63.3-18.6 91.5-35.7 27.7-17 51-40.2 68.2-67.7 19-32.1 28.3-69.1 26.9-106.4v-743h-401.3zM0 2113.7l1391.3 240.8V0L0 240.8z"/>
    <path fill="#fff" d="m1016.7 722.4-642.1 39.1v148.1l240.8-9.7v686.7l160.5 9.4V893.6l240.8-10.7z"/>
  </svg>
);

// Microsoft Outlook Icon (official from n8n)
export const MicrosoftOutlook: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 81 81"
    className={className}
  >
    <g>
      <path fill="#2372ba" stroke="none" d="M77.9 19.2H46.86V0L0 8.232V71.98L46.86 80V61.847H77.9c1.266 0 2.1-1.055 2.1-2.1V21.32c0-1.266-.844-2.1-2.1-2.1zM21.952 54.46c-15.4-1.055-14.776-29.13.422-29.974 16.675-.844 16.253 31.03-.422 29.974m55.515 4.644H46.86V35.04l9.5 9.077c.422.422.844.633 1.477.633s1.055-.2 1.478-.633L77.467 27.23zm0-35.462-19.63 18.153L46.86 31.45v-9.7h30.396v1.9h.2zm-55.092 6.543c-8.232.422-8.443 18.364-.2 18.575 8.654.422 8.654-18.997.2-18.575"/>
    </g>
  </svg>
);

// Microsoft OneDrive Icon (official from n8n)
export const MicrosoftOneDrive: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 81 81"
    className={className}
  >
    <g stroke="none">
      <path fill="#094ab2" d="M6.667 0Q0 0 0 6.667v66.667Q0 80 6.667 80h66.667Q80 80 80 73.333V6.667Q80 0 73.333 0z"/>
      <path d="M60.256 42.023c2.87.405 4.965 2.975 4.832 5.929 0 2.594-1.421 5.655-4.832 5.655H32.574c-5.306 0-7.232-3.706-7.232-7.524 0-6.444 6.979-6.621 6.979-6.621s.569-6.992 6.664-8.41c3.806-1.113 7.875.477 9.98 3.899a8.2 8.2 0 0 1 7.058-.258c2.812 1.257 4.518 4.212 4.232 7.33z"/>
      <path fill="#f9f9f9" d="M23.583 45.605c0-7.082 7.412-8.139 7.412-8.139.707-4.108 3.699-7.435 7.682-8.54 4.021-1.286 8.404.189 10.856 3.653a6.3 6.3 0 0 1 3.635-.737c-.513-4.177-3.247-7.736-7.126-9.277-5.141-2.153-11.058.026-13.618 5.015a8.4 8.4 0 0 0-8.126-.16c-3.181 1.763-5.002 5.282-4.619 8.924-3.675.323-6.438 3.523-6.254 7.242.114 3.817 3.139 6.892 6.92 7.034h4.65a9.1 9.1 0 0 1-1.413-5.015z"/>
      <path fillOpacity=".19" d="m.84 2.69 77.753 75.816A4.4 4.4 0 0 0 80 75.279V4.398A4.39 4.39 0 0 0 75.612 0H4.885A4.39 4.39 0 0 0 .84 2.69"/>
    </g>
  </svg>
);

// Microsoft SharePoint Icon (official from n8n - simplified)
export const MicrosoftSharePoint: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 1992.333 1946"
    className={className}
  >
    <defs>
      <linearGradient id="sharepoint-grad" x1="177.0788" y1="1551.0284" x2="842.2545" y2="398.9716" gradientTransform="matrix(1 0 0 -1 0 1948)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#058F92"/>
        <stop offset="0.5" stopColor="#038489"/>
        <stop offset="1" stopColor="#026D71"/>
      </linearGradient>
    </defs>
    <circle fill="#036C70" cx="1019.333" cy="556" r="556"/>
    <circle fill="#1A9BA1" cx="1482.667" cy="1065.667" r="509.667"/>
    <circle fill="#37C6D0" cx="1088.833" cy="1552.167" r="393.833"/>
    <path opacity="0.1" d="M1112,501.79v988.753c-0.23,34.357-21.05,65.222-52.82,78.303c-10.116,4.279-20.987,6.484-31.97,6.487H695.463c-0.463-7.877-0.463-15.29-0.463-23.167c-0.154-7.734,0.155-15.47,0.927-23.167c8.48-148.106,99.721-278.782,235.837-337.77v-86.18c-302.932-48.005-509.592-332.495-461.587-635.427c0.333-2.098,0.677-4.195,1.034-6.289c2.306-15.626,5.556-31.099,9.73-46.333h546.27C1073.964,417.178,1111.822,455.036,1112,501.79z"/>
    <path opacity="0.2" d="M980.877,463.333H471.21c-51.486,302.386,151.908,589.256,454.293,640.742c9.156,1.559,18.35,2.888,27.573,3.986c-143.633,68.11-248.3,261.552-257.196,420.938c-0.771,7.697-1.081,15.433-0.927,23.167c0,7.877,0,15.29,0.463,23.167c0.836,15.574,2.85,31.063,6.023,46.333h279.39c34.357-0.23,65.222-21.05,78.303-52.82c4.279-10.115,6.485-20.987,6.487-31.97V548.123C1065.443,501.387,1027.613,463.537,980.877,463.333z"/>
    <path opacity="0.2" d="M980.877,463.333H471.21c-51.475,302.414,151.95,589.297,454.364,640.773c6.186,1.053,12.389,2.001,18.607,2.844c-139,73.021-239.543,266-248.254,422.05h284.95c46.681-0.353,84.437-38.109,84.79-84.79V548.123C1065.489,501.369,1027.631,463.511,980.877,463.333z"/>
    <path opacity="0.2" d="M934.543,463.333H471.21c-48.606,285.482,130.279,560.404,410.977,631.616C775.901,1216.384,710.711,1368.301,695.927,1529h238.617c46.754-0.178,84.612-38.036,84.79-84.79V548.123C1019.308,501.306,981.361,463.359,934.543,463.333z"/>
    <path fill="url(#sharepoint-grad)" d="M84.929,463.333h849.475c46.905,0,84.929,38.024,84.929,84.929v849.475c0,46.905-38.024,84.929-84.929,84.929H84.929c-46.905,0-84.929-38.024-84.929-84.929V548.262C0,501.357,38.024,463.333,84.929,463.333z"/>
    <path fill="#FFFFFF" d="M379.331,962.621c-19.903-13.202-36.528-30.777-48.604-51.384c-11.701-21.542-17.533-45.781-16.912-70.288c-1.042-33.181,10.155-65.586,31.46-91.045c22.388-25.49,51.326-44.366,83.678-54.581c36.871-12.136,75.49-18.116,114.304-17.699c51.043-1.865,102.015,5.272,150.583,21.082v106.567c-21.103-12.784-44.088-22.166-68.11-27.8c-26.065-6.392-52.81-9.597-79.647-9.545c-28.3-1.039-56.419,4.913-81.871,17.329c-19.65,8.475-32.392,27.807-32.433,49.206c-0.08,12.981,4.907,25.481,13.9,34.843c10.622,11.037,23.187,20.021,37.067,26.503c15.444,7.691,38.611,17.916,69.5,30.673c3.401,1.075,6.716,2.407,9.915,3.985c30.401,11.881,59.729,26.344,87.663,43.229c21.154,13.043,38.908,30.924,51.801,52.171c13.218,24.085,19.625,51.315,18.533,78.767c1.509,34.066-8.913,67.591-29.468,94.798c-20.488,25.012-47.88,43.446-78.767,53.005c-36.329,11.387-74.245,16.892-112.312,16.309c-34.154,0.155-68.258-2.635-101.933-8.34c-28.434-4.653-56.182-12.807-82.612-24.279v-112.358c25.264,18.043,53.489,31.529,83.4,39.847c29.81,9.289,60.798,14.251,92.018,14.734c28.895,1.83,57.739-4.291,83.4-17.699c17.976-10.144,28.909-29.358,28.449-49.994c0.12-14.359-5.56-28.158-15.753-38.271c-12.676-12.444-27.352-22.671-43.414-30.256c-18.533-9.267-45.824-21.483-81.871-36.65C432.618,993.951,405.161,979.594,379.331,962.621z"/>
  </svg>
);

// Microsoft SQL Server Icon (official from n8n - simplified)
export const MicrosoftSqlServer: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    className={className}
  >
    <defs>
      <linearGradient id="mssql-grad" x1="0.5" y1="10.04" x2="13.18" y2="10.04" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#005ba1"/>
        <stop offset="0.07" stopColor="#0060a9"/>
        <stop offset="0.36" stopColor="#0071c8"/>
        <stop offset="0.52" stopColor="#0078d4"/>
        <stop offset="0.64" stopColor="#0074cd"/>
        <stop offset="0.82" stopColor="#006abb"/>
        <stop offset="1" stopColor="#005ba1"/>
      </linearGradient>
    </defs>
    <path d="M6.84,5.09c-3.5,0-6.34-1-6.34-2.3V15c0,1.26,2.79,2.28,6.25,2.3h.09c3.5,0,6.34-1,6.34-2.3V2.79C13.18,4.06,10.34,5.09,6.84,5.09Z" fill="url(#mssql-grad)"/>
    <path d="M13.18,2.79c0,1.27-2.84,2.3-6.34,2.3S.5,4.06.5,2.79,3.34.49,6.84.49s6.34,1,6.34,2.3" fill="#e8e8e8"/>
    <path d="M11.7,2.6c0,.81-2.18,1.46-4.86,1.46S2,3.41,2,2.6,4.16,1.14,6.84,1.14,11.7,1.8,11.7,2.6" fill="#50e6ff"/>
    <path d="M6.84,2.94A12,12,0,0,0,3,3.49a11.25,11.25,0,0,0,3.85.57,11.25,11.25,0,0,0,3.85-.57A12,12,0,0,0,6.84,2.94Z" fill="#198ab3"/>
    <path d="M10.74,11.1V7.72H9.81v4.14h2.46V11.1ZM3.59,9.43a1.92,1.92,0,0,1-.51-.31A.44.44,0,0,1,3,8.8a.38.38,0,0,1,.16-.31.72.72,0,0,1,.42-.11,1.67,1.67,0,0,1,1,.29V7.81a2.67,2.67,0,0,0-1-.16A1.74,1.74,0,0,0,2.38,8a1.13,1.13,0,0,0-.41.9c0,.51.32.91,1,1.21a2.9,2.9,0,0,1,.61.36.4.4,0,0,1,.16.32.38.38,0,0,1-.16.31.75.75,0,0,1-.45.12A1.6,1.6,0,0,1,2,10.77v.93a2.29,2.29,0,0,0,1.07.23,2,2,0,0,0,1.18-.32,1.1,1.1,0,0,0,.43-.92,1,1,0,0,0-.25-.7A2.42,2.42,0,0,0,3.59,9.43ZM8.79,11a2.4,2.4,0,0,0,.33-1.27,2.32,2.32,0,0,0-.25-1.1,1.81,1.81,0,0,0-.7-.75,2,2,0,0,0-1-.26,2.18,2.18,0,0,0-1.09.27,1.87,1.87,0,0,0-.73.77,2.41,2.41,0,0,0-.26,1.15,2.26,2.26,0,0,0,.24,1.05,1.83,1.83,0,0,0,.68.75,2,2,0,0,0,1,.29l.85,1H9.05l-1.2-1.11A1.81,1.81,0,0,0,8.79,11Zm-.93-.26a1,1,0,0,1-1.53,0,1.51,1.51,0,0,1-.28-1,1.48,1.48,0,0,1,.29-1,.92.92,0,0,1,.78-.37.89.89,0,0,1,.75.37,1.62,1.62,0,0,1,.27,1A1.46,1.46,0,0,1,7.86,10.77Z" fill="#f2f2f2"/>
    <path d="M14.81,17.49l.24-.79.47-.27.81.36.52-.53V16.2l-.37-.71.22-.5.81-.29.09,0v-.73l-.1,0-.8-.24-.26-.46.35-.82-.53-.51H16.2l-.71.36L15,12l-.32-.89h-.74l0,.11-.24.79-.51.22-.87-.4-.51.53.05.1.38.74-.2.51L11.1,14v.74l.11,0,.79.24.22.51-.39.86.53.52.09-.05.74-.38.51.2.34.89h.73Zm-1.2-2.36a1.06,1.06,0,1,1,1.49-1.52,1.06,1.06,0,0,1-1.49,1.52Z" fill="#949494"/>
  </svg>
);

// Azure Blob Storage Icon (from official Azure icon set)
export const AzureBlobStorage: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    className={className}
  >
    <defs>
      <linearGradient id="azure-blob-grad" x1="9" y1="15.834" x2="9" y2="5.788" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#32bedd"/>
        <stop offset="0.775" stopColor="#32d4f5"/>
      </linearGradient>
    </defs>
    <path d="M.5,5.788h17a0,0,0,0,1,0,0v9.478a.568.568,0,0,1-.568.568H1.068A.568.568,0,0,1,.5,15.266V5.788A0,0,0,0,1,.5,5.788Z" fill="url(#azure-blob-grad)"/>
    <path d="M1.071,2.166H16.929a.568.568,0,0,1,.568.568V5.788a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V2.734A.568.568,0,0,1,1.071,2.166Z" fill="#0078d4"/>
    <rect x="2.328" y="7.049" width="6.281" height="3.408" rx="0.283" fill="#0078d4"/>
    <rect x="9.336" y="7.049" width="6.281" height="3.408" rx="0.283" fill="#fff"/>
    <rect x="2.296" y="11.128" width="6.281" height="3.408" rx="0.283" fill="#0078d4"/>
    <rect x="9.304" y="11.128" width="6.281" height="3.408" rx="0.283" fill="#0078d4"/>
  </svg>
);

// Azure Storage Account Icon (official from n8n)
export const AzureStorageAccount: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    className={className}
  >
    <defs>
      <linearGradient id="azure-storage-grad" x1="9" y1="15.83" x2="9" y2="5.79" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3"/>
        <stop offset=".26" stopColor="#c1c1c1"/>
        <stop offset="1" stopColor="#e6e6e6"/>
      </linearGradient>
    </defs>
    <path d="M.5 5.79h17v9.48a.57.57 0 01-.57.57H1.07a.57.57 0 01-.57-.57V5.79z" fill="url(#azure-storage-grad)"/>
    <path d="M1.07 2.17h15.86a.57.57 0 01.57.57v3.05H.5V2.73a.57.57 0 01.57-.56z" fill="#37c2b1"/>
    <path d="M2.81 6.89h12.37a.27.27 0 01.26.27v1.4a.27.27 0 01-.26.27H2.81a.27.27 0 01-.26-.27v-1.4a.27.27 0 01.26-.27z" fill="#fff"/>
    <path d="M2.82 9.68h12.37a.27.27 0 01.26.27v1.41a.27.27 0 01-.26.27H2.82a.27.27 0 01-.26-.27V10a.27.27 0 01.26-.32z" fill="#37c2b1"/>
    <path d="M2.82 12.5h12.37a.27.27 0 01.26.27v1.41a.27.27 0 01-.26.27H2.82a.27.27 0 01-.26-.27v-1.41a.27.27 0 01.26-.27z" fill="#258277"/>
  </svg>
);

// Microsoft Entra ID Icon (official from n8n)
export const MicrosoftEntra: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    className={className}
  >
    <path fill="#225086" d="M2.63 8.4l5.15-5.02a.47.47 0 0 1 .66 0l5.15 5.02a.47.47 0 0 1 0 .67L8.44 14.1a.47.47 0 0 1-.66 0L2.63 9.07a.47.47 0 0 1 0-.67z"/>
    <path fill="#66DDFF" d="M8.11 1.07a.47.47 0 0 1 .66 0l5.15 5.02a.47.47 0 0 1 0 .67l-2.58 2.51-3.23-3.15-3.23 3.15L2.3 6.76a.47.47 0 0 1 0-.67z"/>
    <path fill="#CBF8FF" d="M8.11 1.07a.47.47 0 0 1 .66 0l5.15 5.02a.47.47 0 0 1 0 .67l-2.58 2.51L8.11 6.12z"/>
    <path fill="#074793" d="M8.44 14.1a.47.47 0 0 1-.66 0L2.63 9.07a.47.47 0 0 1 0-.67l2.25-2.19 3.56 3.47 3.56-3.47 2.25 2.19a.47.47 0 0 1 0 .67z"/>
    <path fill="#0294E4" d="M14.07 9.07a.47.47 0 0 1 0 .67L8.92 14.1a.47.47 0 0 1-.48.1V6.12l2.9 2.83z"/>
    <path fill="#96BCC2" d="M8.44 6.12l2.9 2.83-2.9 2.83z"/>
  </svg>
);

// Microsoft Azure Generic Icon
export const MicrosoftAzure: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
  >
    <path fill="#0089D6" d="M13.05 4.24L6.56 18.05a.5.5 0 0 0 .45.71h9.54L13.05 4.24z"/>
    <path fill="#0089D6" d="M7.96 4.24l-4.87 14.4a.5.5 0 0 0 .47.67h5.35l5.51-12.77L7.96 4.24z"/>
    <path fill="#50E6FF" d="M13.05 4.24l3.5 14.52h4.36a.5.5 0 0 0 .47-.68L13.05 4.24z"/>
  </svg>
);

// Map of icon names to components
export const microsoftIconsMap: Record<string, React.FC<IconProps>> = {
  // Azure Blob Storage - multiple aliases
  'azure-blob-storage': AzureBlobStorage,
  'azureBlobStorage': AzureBlobStorage,

  // Azure Storage Account
  'azure-storage': AzureStorageAccount,
  'azureStorage': AzureStorageAccount,

  // Microsoft Teams
  'microsoft-teams': MicrosoftTeams,
  'microsoftTeams': MicrosoftTeams,

  // Microsoft Outlook
  'microsoft-outlook': MicrosoftOutlook,
  'microsoftOutlook': MicrosoftOutlook,

  // Microsoft OneDrive
  'microsoft-onedrive': MicrosoftOneDrive,
  'microsoftOnedrive': MicrosoftOneDrive,

  // Microsoft SharePoint
  'microsoft-sharepoint': MicrosoftSharePoint,
  'microsoftSharepoint': MicrosoftSharePoint,

  // Microsoft Entra ID
  'microsoft-entra': MicrosoftEntra,
  'microsoftEntra': MicrosoftEntra,

  // Microsoft SQL Server
  'sql-server': MicrosoftSqlServer,
  'ms-sql': MicrosoftSqlServer,
  'MsSQL': MicrosoftSqlServer,
  'microsoftSqlServer': MicrosoftSqlServer,

  // Microsoft Azure (generic)
  'microsoft-azure': MicrosoftAzure,
  'azure': MicrosoftAzure,
};

// Get Microsoft icon component by name
export function getMicrosoftIcon(name: string): React.FC<IconProps> | undefined {
  return microsoftIconsMap[name];
}

// Check if a Microsoft icon exists
export function hasMicrosoftIcon(name: string): boolean {
  return name in microsoftIconsMap;
}
